<template>
  <div class="item">
    <h3 class="item-title">{{decodeURIComponent(classItem.title)}}</h3>
    <p class="item-time">发布时间:{{classItem.addtime.substring(0,16)}}</p>
    <p class="item-name">老师姓名:{{decodeURIComponent(classItem.teachername)}}</p>
    <button class="edit-btn" @click="goEdit(classItem)">
      <template v-if="isComplete">查看</template>
      <template v-else>回复</template>
    </button>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      id: {
        type: String
      },
      classinfo: {
        type: Object
      },
      isComplete:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        classItem: '',
        titlename: '',
      }
    },
    methods: {
      goEdit(item) {
        //如果已经完结了
        if(this.isComplete){
          this.$router.push(
            {
              path: '/homework/complete',
              query: {
                title: decodeURIComponent(item.title),
                rid: item.rid,
                lessonid: item.lessonid,
                classid: item.classid,
                homeworkid: item.id,
              }
            }
          )
        }else{
          this.$router.push(
            {
              path: '/homework/sedit',
              query: {
                title: decodeURIComponent(item.title),
                rid: item.rid,
                lessonid: item.lessonid,
                classid: item.classid,
                homeworkid: item.id
              }
            }
          )
        }
      }
    },
    created() {

    },
    mounted() {

    },
    watch: {
      classinfo: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler(val, oldVal) {
          this.classItem = this.classinfo;
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .item {
    display: inline-block;
    padding-left: 30px;
    width: 478px;
    height: 200px;
    margin: 0 10px 10px 0;
    box-sizing: border-box
    background: #fff
    border-radius: 6px
    position: relative
    vertical-align: top
    &:nth-child(2n) {
      margin-right: 0px
    }
    .item-title {
      margin: 30px 0 10px;
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      vertical-align: middle
    }
    .item-time, .item-name {
      font-size: 16px;
      color: #999;
      height: 22px;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .item-name {
      margin-bottom: 29px;
    }
    .item-noanswer {
      font-size: 16px;
      color: #ff6700;
    }
    .answer-btn, .edit-btn {
      position: absolute;
      bottom: 20px;
      display: inline-block;
      font-size: 16px;
      color: #333;
      width: 100px;
      height: 32px;
      line-height: 30px;
      box-sizing: border-box
      border-radius: 4px;
      border: 1px solid #e9e9e9
      &:hover {
        color: #ff6700;
        border-color: #ff6700
      }
    }
    .answer-btn {
      right: 140px;
    }
    .edit-btn {
      right: 30px;
      .hint-dot {
        position: absolute;
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #ff6700;
        top: 4px;
        right: 22px
        border-radius: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/account/personal/work/component/workitem.vue